import React from 'react';
import {formatToPersianAddComma} from "../../../utils/CommaSeparator";

function FooterPrintSellFactor({data}) {

  console.log(data)

  let sum, tax, sumExtra, totalSum, service, discount;

  sum = data.headerAndFooter.footer.find(v => v.id === "Memo62")
  service = data.headerAndFooter.footer.find(v => v.id === "Memo64")
  // tax = data.headerAndFooter.footer.find(v => v.id === "Memo16")
  discount = data.headerAndFooter.footer.find(v => v.id === "Memo63")
  // sumExtra = data.headerAndFooter.footer.find(v => v.id === "Memo16")
  totalSum = data.headerAndFooter.footer.find(v => v.id === "Memo65")

  return (<div className={"w-100 "}>
    <div className={"d-flex justify-content-between mt-1 rtl"}>
      <div className={"border9BA5B7 w-50 text-end p-2 ms-1"}>توضیحات:</div>
      <div className={"footer__table__InFactorPrint w-50"}>
        <ul>
          <li>{sum?.label}</li>
          <li>{formatToPersianAddComma(sum?.value)}</li>
        </ul>
        <ul>
          <li>{service?.label}</li>
          <li>{formatToPersianAddComma(service?.value)}</li>
        </ul>
        <ul>
          <li>{discount?.label}</li>
          <li>{formatToPersianAddComma(discount?.value)}</li>
        </ul>
        <ul>
          <li>{totalSum?.label}</li>
          <li>{formatToPersianAddComma(totalSum?.value)}</li>
        </ul>
      </div>
    </div>
    <div className={"d-flex w-100 mt-1"}>
      <div className={"height40 border9BA5B7 text-end px-1 w-25 rtl"}> تهیه کننده:</div>
      <div className={"height40 border9BA5B7 text-end px-1 w-25 ms-1 rtl"}>رییس حسابداری:</div>
      <div className={"height40 border9BA5B7 text-end px-1 w-25 ms-1 rtl"}>مدیر مالی:</div>
      <div className={"height40 border9BA5B7 text-end px-1 w-25 rtl"}>مدیر عامل:</div>
    </div>


  </div>);
}

export default FooterPrintSellFactor;